import Lang from "@/lang";
import { Filter } from "@/types/filters";

const allItems = [{ text: Lang.all, value: null }];

export const campaignBudget = [
  {
    text: Lang.all,
    value: null,
  },
  {
    text: Lang.underValue("$500k"),
    value: {
      max: 500000,
    },
  },
  {
    text: Lang.betweenValues("$500k", "$1M"),
    value: {
      min: 500000,
      max: 1000000,
    },
  },
  {
    text: Lang.betweenValues("$1M", "$3M"),
    value: {
      min: 1000000,
      max: 3000000,
    },
  },
  {
    text: Lang.betweenValues("$3M", "$5M"),
    value: {
      min: 3000000,
      max: 5000000,
    },
  },
  {
    text: Lang.betweenValues("$5M", "$10M"),
    value: {
      min: 5000000,
      max: 10000000,
    },
  },
  {
    text: Lang.betweenValues("$10M", "$20M"),
    value: {
      min: 10000000,
      max: 20000000,
    },
  },
  {
    text: Lang.aboveValue("$20M"),
    value: {
      min: 20000000,
    },
  },
];

export const b2bb2c = [
  {
    text: Lang.all,
    value: null,
  },
  {
    text: Lang.b2b,
    value: "b2b",
  },
  {
    text: Lang.b2c,
    value: "b2c",
  },
];

export const dashboardFilters: Array<Filter> = [
  {
    label: Lang.dateRange,
    filterName: "DateRangeFilter",
    filterKey: "dateRange",
    apiKey: "dateRange",
    value: null,
    isPageDetails: true,
    default: "last12Months",
  },
  {
    label: Lang.industry,
    filterName: "MultipleSelectFilter",
    filterKey: "industry",
    apiKey: "industry",
    value: null,
    isPageDetails: true,
    items: allItems,
    searchBar: true,
  },
  {
    label: Lang.businessGoal,
    filterName: "MultipleSelectFilter",
    filterKey: "businessGoal",
    apiKey: "business_goal",
    value: null,
    isPageDetails: true,
    items: allItems,
    searchBar: true,
  },
  {
    label: Lang.campaignKPIS,
    filterName: "MultipleSelectFilter",
    filterKey: "campaignKpi",
    apiKey: "campaign_kpi",
    value: null,
    isPageDetails: true,
    items: allItems,
    searchBar: true,
  },
  {
    label: Lang.channel,
    filterName: "MultipleSelectFilter",
    filterKey: "channel",
    apiKey: "channel",
    value: null,
    isPageDetails: true,
    items: allItems,
    searchBar: true,
  },
  {
    label: Lang.agency,
    filterName: "MultipleSelectFilter",
    filterKey: "agency",
    apiKey: "agency",
    value: null,
    items: allItems,
    searchBar: true,
  },
  {
    label: Lang.advertiser,
    filterName: "MultipleSelectFilter",
    filterKey: "advertiser",
    apiKey: "advertiser",
    value: null,
    items: allItems,
    searchBar: true,
  },
  {
    label: Lang.b2bb2c,
    filterName: "MultipleSelectFilter",
    filterKey: "b2b_b2c",
    apiKey: "b2b_b2c",
    value: null,
    items: allItems,
    searchBar: false,
  },
  {
    label: Lang.mediaType,
    filterName: "MultipleSelectFilter",
    filterKey: "mediaType",
    apiKey: "media_type",
    value: null,
    items: allItems,
    searchBar: true,
  },
  {
    label: Lang.dsp,
    filterName: "MultipleSelectFilter",
    filterKey: "dsp",
    apiKey: "dsp",
    value: null,
    items: allItems,
    searchBar: true,
  },
  {
    label: Lang.campaign,
    filterName: "MultipleSelectFilter",
    filterKey: "campaign",
    apiKey: "campaign_name",
    value: null,
    items: allItems,
    searchBar: true,
  },
  {
    label: Lang.campaignId,
    filterName: "MultipleSelectFilter",
    filterKey: "campaignId",
    apiKey: "campaign_id",
    value: null,
    items: allItems,
    searchBar: true,
  },
  {
    label: Lang.campaignBudget,
    filterName: "MultipleSelectFilter",
    filterKey: "campaignBudget",
    apiKey: "budgets",
    value: null,
    items: allItems,
    searchBar: true,
  },
  {
    label: Lang.dma,
    filterName: "MultipleSelectFilter",
    filterKey: "dma",
    apiKey: "dma",
    value: null,
    items: allItems,
    searchBar: true,
  },
  {
    label: Lang.store,
    filterName: "MultipleSelectFilter",
    filterKey: "store",
    apiKey: "store",
    value: null,
    items: allItems,
    searchBar: true,
  },
  {
    label: Lang.dataType,
    filterName: "MultipleSelectFilter",
    filterKey: "data_type",
    apiKey: "data_type",
    value: null,
    items: allItems,
    searchBar: false,
  },
];
